import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../ProjectFinder2/ProjectFinder2HomeTypes";
import { ProjectWizardV2 as ProjectWizard, EvBookingAgenda, ProjectView } from '../_loadingHelpers/VAMv2';
import { VAM2types } from '../_loadingHelpers/VAMv2Types';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import EventFinderLM from '../EventFinder/EventFinderLM';
import { DateHelpers, FeatureHelpers } from "../../more/Helpers";

class ProjectFinder2Home extends compose(FinderBaseV2) {
	//templateString = template;


    private createNewEntity(evt: MouseEvent = null, isPeriod: boolean = false) {

        if (!this.hasUserRole(["Projects_Create", "Projects_Edit"])) return;

        let form = new ProjectWizard();
        form.setIsPeriod(isPeriod);

        if (this.isEmbeddedInTab) {
            if (this.isEmbeddedInTab) {
                let name = "newProject-" + (Math.random() * 100000).toFixed(0).toString();
                let tabConfig: Tabbing.TabPageDescriptor = {
                    enableClosing: true,
                    label: this.translations["Projects__CreateNew"],
                    name: name,
                    sidebarEntryName: name,
                    widget: form,
                    groupLabel: this.translations["Projects__CreateNew"],
                    //coloration: "w3-blue"
                };

                this.requestNewTabbedContent(tabConfig, true);

                this.requestTabswitch(tabConfig.name);
            }
        }

        else {


            let dlg = new GenericDialog();

            dlg.closeOnEnter = false;
            dlg.closeOnEscape = false;
            //dlg.setUserdefinedButton("Fertig!", "", lang.hitch(this, this._onCloseDetailsDlg_Callback, dlg, form))
            dlg._setCallbackAttr(lang.hitch(this, this._onCloseDetailsDlg_Callback, dlg, form));
            dlg._setCloseBtnAttr(true);
            dlg._setTopCloseBtnAttr(true);

            dlg.enableContentOverflow(true);
            //dlg._setCallbackAttr(lang.hitch(this, this._onCloseDetailsDlg_Callback, dlg, form))
            dlg.show();
            dlg.addNodeToContent(form.domNode);
        }

        form.setStartupState("ready");
        //form.startup();

    }
    protected _beforeTableDrawn() {
    //    this.table.setupExpandableRows(lang.hitch(this, this._expanderSetupCallback), lang.hitch(this, this._expanderClickCallback));
    }

    private _expanderSetupCallback(rowgroup: StaticTable.StaticTableRowGroup<VAM2types.EvProjectEntity_Base>): HTMLElement {


        if (rowgroup.entity.note) {
            let element = this.UiModder.domConstruct.create("pre", {
                "innerHTML": rowgroup.entity.note,
                classname: "transparent"
            });

            return element;
        }

        return null;

    }

    //private createdViews: Record<string, any> = {};

    private _expanderClickCallback(expandState: boolean, container: HTMLElement, rowgroup: StaticTable.StaticTableRowGroup<VAM2types.EvProjectEntity_Base>) {
    //    let existingRecord = this.createdViews[rowgroup.entity.ID];
    //    if (existingRecord) return;

    //    let view = new ProjectView();
    //    view.showAtNode(rowgroup.entity.ID, rowgroup.displayname, container, false);

    //    this.createdViews[rowgroup.entity.ID] = view;
    }

    

    private _onClick_Row(row: StaticTable.StaticTableRow<VAM2types.EvProjectEntity_Base>) {


        let entity = row.rowGroup.entity;
        let label = "";
        let entityId = entity.ID;

        if (!entityId) return;

        this.openProject(entity);

    }

    openProject(entity: VAM2types.EvProjectEntity_Base) {
        if (!entity) return;

        let entityId = entity.ID;

        let view = new ProjectView();
        
        view.showAsDlg(entityId, entity.ev_project_name, this.getTabContainerName(), entity.$Displayname);

        //if (this.hasFeature("EvProject/ProjectWizard")) {
        //    view.forceOpenEditor(entityId, entity.Classname, entity.ev_project_name, this.getTabContainerName());
        //} else {
        //    view.showAsDlg(entityId, entity.ev_project_name);
        //}

        view.on("change", lang.hitch(this, this.reload));
        view.on("deleted", lang.hitch(this, this.reload));
        view.on("closed", lang.hitch(this, this._onCloseProjectView, entityId));

    //    let urlIds = this.getUrlParameterValue("pid") as string;
    //    let openIds = [];
    //    if (urlIds) {
    //        openIds = urlIds.split(";");
    //    }

    //    openIds.push(entityId);

    //    this.setUrlParameter("pid", openIds.join(";"));
    }

    private _onCloseProjectView(entityId: string) {
        if (!entityId) return;

        let urlIds = this.getUrlParameterValue("pid") as string;
        let openIds = [];
        if (urlIds) {
            openIds = urlIds.split(";");
        }

        let index = openIds.indexOf(entityId);
        if (index >= 0) openIds.splice(index, 1);

        this.setUrlParameter("pid", openIds.join(";"));
    }

    private _onCloseDetailsDlg_Callback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof ProjectWizard>>) {
        let hasChanged = form.isDirty();
        if (hasChanged) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translations["General_AskSavePendingChanges"],
                this.translations["General_PendingChanges"],
                "",
                "",
                "yesno",
                lang.hitch(this, this._confirmCallback, dlg, form)
            );

        } else {
            dlg.close();
        }
    }

    private _confirmCallback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof ProjectWizard>>, result) {
        if (result == -1) { // nein - nicht speichern
            dlg.close();
        } else {
            form.on("saveComplete", lang.hitch(dlg, dlg.close))
            form.save();
        }
    }

    private projectTable_formatterFunction(cell: StaticTable.StaticTableCell<any>): boolean{ // formatter
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
            case "date_start":
            case "date_end":
            case "date_from":
            case "date_to":
                let date = entity[cell.name];
                if (date) {
                    let txtDate = this.dateTimeToString(new Date(date), "dd.MM.yyyy HH:mm");

                    node.innerHTML = txtDate;
                }
                return true;

                break;
            case "date":
                let dateFrom = entity.date_start;
                let dateTo = entity.date_end;

                let txtDateFrom = "?";
                let txtdateTo = "?";

                if (dateFrom) {
                    txtDateFrom = this.dateTimeToString(new Date(dateFrom), "dd.MM.yyyy HH:mm");
                }

                if (dateTo) {
                    txtdateTo = this.dojoDate.format(new Date(dateTo), {
                        datePattern: "dd.MM.yyyy",
                        timePattern: "HH:mm",
                        selector: "date"
                    });

                }
                node.innerHTML = this.stringFormat(this.translations["ProjectList_DateRangeFormat"], txtDateFrom, txtdateTo);
                this.UiModder.domClass.add(node, "projectlist_DateRange");
                return true;

                break;
            case "note":
                if (cell.value == "" || cell.value == null) {
                    this.UiModder.domClass.add(cell.tableRow.node, "w3-hide");
                }
                return true;
                break;
            default:
                return false;
        }

        return false;
    }

    private _onClick_ShowEvBookingAgenda() {

        /*let widget = new EvBookingAgenda();
            

            this.requestNewTabbedContent({
                enableClosing: true,
                label: this.translations["General_Label_EvBookings"],
                name: "evbAgenda",
                sidebarEntryName: "evbAgenda",
                widget: widget,
                heading: this.translations["General_Label_AdditionalViews"],
                iconclass: "fas fa-th"
            })

        widget.startup();*/

        this.requestTabswitch("evbAgenda")

    }

    private _onClick_ShowEvBookingsLM() {
        let widget = new EventFinderLM();


        this.requestNewTabbedContent({
            enableClosing: true,
            label: this.translations["General_Label_EvBookings"],
            name: "EvBookingLM",
            sidebarEntryName: "EvBookingLM",
            widget: widget,
            groupLabel: this.translations["General_LastModified"],
            iconclass: "fas fa-history"
        },true)
    }

    _onEmbedding(): void {


        this.hasUserRole("dummy", lang.hitch(this, this._handleButtons));

        //this.requestContextButton({
        //    callback: lang.hitch(this, function () { console.log("BUBUBU"); }),
        //    label: "Irgendeine Aktion",
        //    placement: "actionbar",
        //    permanent: true,
        //    //heading: "Übi1",
        //    order: 100
        //});

        //this.requestContextButton({
        //    callback: lang.hitch(this, function () { console.log("BUBUBU"); }),
        //    label: "BUBUBU",
        //    placement: "actionmenu",
        //    permanent: true,
        //    //heading: "Übi1",
        //    order: 100
        //});

        //this.requestContextButton({
        //    callback: lang.hitch(this, function () { console.log("item2"); }),
        //    label: "item2",
        //    placement: "actionmenu",
        //    permanent: true,
        //    //heading: "Übi1",
        //    order: 101
        //});
    }

    private _onClick_NewPeriod(evt: MouseEvent) {
        this.createNewEntity(evt, true);
    }

    private _handleButtons() {

        if (this.hasUserRole(["Projects_Create", "Projects_Edit", "ProjectFinder_CreateNewPeriod"])) this.addButtonMainContainer({ label: "ProjectFinder_Label_NewPeriod", name: "newPerdiodBtn", icon: "fas fa-plus-circle", callback: lang.hitch(this, this._onClick_NewPeriod) });
        if (this.hasUserRole("ProjectFinder_CreateNewPeriod")) this.removeButtonMainContainer("newButton");

        // Ambach braucht den Neu-Button unbedingt auch auf der Agendaview der VA_Buchungen. daher per Feature updaten:
        if (FeatureHelpers.hasFeature("Planning/AllowPermanentCreateProjectButton") && this.hasUserRole("Projects_Create")) {
            this.updateContextButton("new", {
                permanent: true,
                label:"Projects__CreateNew"
            });
        }

        //if (this.hasUserRole(["Projects_Create", "Projects_Edit"])) {
        //    this.requestContextButton({
        //        label: this.translate('Projects__CreateNew'),
        //        permanent: true,
        //        name: "createProject",
        //        heading: this.translate('Projects__MainTitle'),
        //        placement: "topmenu",
        //        iconClass: "fas fa-plus-circle",
        //        callback: lang.hitch(this, this.createNewEntity)
        //    })
        //};


        //if (this.hasFeature("Planning/EvBookingAgenda")) {
        //    this.requestContextButton({
        //        callback: lang.hitch(this, this._onClick_ShowEvBookingAgenda),
        //        label: this.stringFormat("{0} - {1}", this.translations["General_Label_EvBookings"], this.translations["EvBooking_AgendaMainTitle"]),
        //        permanent: true,
        //        heading: this.translations["General_Label_AdditionalViews"],
        //        order: 10,
        //        placement: "topmenu",
        //        iconClass: "fas fa-th"
        //    });
        //}

    //    if (this.hasFeature("Planning/EventFinderLM")) {
    //        this.requestContextButton({
    //            callback: lang.hitch(this, this._onClick_ShowEvBookingsLM),
    //            label: this.stringFormat("{0} - {1}", this.translations["General_Label_EvBookings"], this.translations["General_LastModified"]),
    //            permanent: true,
    //            heading: this.translations["General_Label_AdditionalViews"],
    //            order: 12,
    //            placement: "topmenu",
    //            iconClass: "fas fa-history"
    //        });
    //    }
    }

    //-----------------------own methods -------------------------end

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.useStandbyManager = true;

        this.RequestManager.handleAs = "json";
        if (this.hasFeature("PlanningSection", "killProjectFinderHome") == true){
            try {
                (this.destroyRecursive as any)();
            } catch { }
            return;
        }

        this.finderSetup({
            configUrl: "ProjectFinder2/GetFilterpanelOptions",
            filterdataUrl: "ProjectFinder2/GetProjectList",
            configCallfunction: null,
            filterdataCallfunction: null,
            rowClickFunction: lang.hitch(this, this._onClick_Row),
            tableFormatterFunction: lang.hitch(this, this.projectTable_formatterFunction),
            labelProperty: "ev_project_name",
            //showIndexColum: true,
            newEntryParams: {
                neededUserRole: ["Projects_Create", "Projects_Edit"],
                callback: lang.hitch(this, this.createNewEntity)
            },
            tableRowExpanderConfig: { contentSetupCallback: lang.hitch(this, this._expanderSetupCallback), expandClickCallback: lang.hitch(this, this._expanderClickCallback) }

        });

        

        this.addSubscription("ProjectFinder2/RequestNew", lang.hitch(this, this.createNewEntity));
        this.addSubscription("EvProject/Cloned", lang.hitch(this, this.reload));
        this.addSubscription("EvProject/Deleted", lang.hitch(this, this.reload));

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(ProjectFinder2Home);
